import * as React from 'react';

import * as HttpStatus from 'http-status-codes';
import qs from 'qs';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { Loader } from 'components/loader/Loader';
import { clientConfig } from 'config/client';
import { STATUSES } from 'core/api';
import localStorage from 'core/local-storage/localStorage';

import { LoginPage } from './components/LoginPage';
import { FORBIDDEN_ERROR, UserTypes } from './constants';
import { IProps, IState } from './interfaces';
import { fetchCurrentUser } from './redux';

function getDisplayName<T>(component: React.ComponentType<T>): string {
  return component.displayName || component.name || 'Component';
}

export const withAuth = (types?: UserTypes[]) => <T extends object | undefined>(
  Component: React.ComponentType<T>,
): any => {
  class WrapperComponent extends React.Component<
    T & IProps & RouteComponentProps,
    IState
  > {
    public static displayName: string;

    public state = {
      error: null,
    };

    public async componentDidMount(): Promise<void> {
      const { user } = this.props;

      if (user.status === STATUSES.SUCCESS) {
        return;
      }

      try {
        const { data } = await this.props.fetchCurrentUser();

        const userId = data && data.username;

        if (userId) {
          console.log('@debug userId: ', userId);
        }
      } catch (e) {
        localStorage.remove(clientConfig.tokenParamName);
        localStorage.remove('X-Intranet-Token');
      }
    }

    public render() {
      const {
        user: { status, data },
      } = this.props;

      switch (status) {
        case STATUSES.REQUEST:
          return <Loader />;
        case STATUSES.FAILED: {
          return <LoginPage error={this.getError()} />;
        }
        case STATUSES.SUCCESS:
          const userType = data && data.data && data.data.type;

          if (types && !types.includes(userType)) {
            return <LoginPage withoutRedirect={true} />;
          }

          return <Component {...this.props} />;
        default:
          return null;
      }
    }

    private readonly getError = (): string | null => {
      const {
        user: { error },
        location,
      } = this.props;

      const queryParams = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });

      if (error === String(HttpStatus.FORBIDDEN)) {
        return FORBIDDEN_ERROR;
      }

      if (
        queryParams.error &&
        queryParams.error === String(HttpStatus.FORBIDDEN)
      ) {
        return FORBIDDEN_ERROR;
      }

      if (error === String(HttpStatus.UNAUTHORIZED)) {
        return null;
      }

      return error as string;
    };
  }

  WrapperComponent.displayName = `Auth[${getDisplayName<T>(Component)}]`;

  const mapState = (state: any) => ({
    user: state.user,
  });

  const mapDispatch = {
    fetchCurrentUser,
  };

  return compose(
    withRouter,
    connect(mapState, mapDispatch),
  )(WrapperComponent as any);
};
